import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { STRINGS } from "./strings";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const STORAGE_KEY = "app:lang";
const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("ar");
  const { user } = useAuth();

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "ar" || stored === "en") {
      setLangState(stored);
    } else if (user?.language === "ar" || user?.language === "en") {
      setLangState(user.language);
    }
  }, [user?.language]);

  // Apply document direction
  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback(async (l) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
    try { await api("/auth/profile", { method: "PUT", body: JSON.stringify({ language: l }) }); } catch {}
  }, []);

  const t = useCallback((key) => {
    const entry = STRINGS[key];
    if (!entry) return key;
    return entry[lang] || entry.ar || key;
  }, [lang]);

  return (
    <Ctx.Provider value={{ lang, setLang, t, isRTL: lang === "ar" }}>
      {children}
    </Ctx.Provider>
  );
}

export function useT() {
  const ctx = useContext(Ctx);
  if (!ctx) {
    return {
      lang: "ar",
      setLang: async () => {},
      t: (key) => STRINGS[key]?.ar || key,
      isRTL: true,
    };
  }
  return ctx;
}
